import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/inventory-vendors/new/loading';

export const Route = createFileRoute('/_private/settings/inventory-vendors/new')({
  component: Loading,
});
